import { render, staticRenderFns } from "./Profitability.vue?vue&type=template&id=2b64dcf3&scoped=true&"
import script from "./Profitability.vue?vue&type=script&lang=js&"
export * from "./Profitability.vue?vue&type=script&lang=js&"
import style0 from "./Profitability.vue?vue&type=style&index=0&id=2b64dcf3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64dcf3",
  null
  
)

export default component.exports